module.exports = __webpack_public_path__ + "img/1_008.7b5cc254.jpg";